export { default as MemberSpotlight } from "./components/Main";
export { default as MemberSpotlightPreview } from "./components/Preview";
export type { MemberSpotlightProps } from "./components/Main";
